import { useMemo } from "react";

import { Experiments } from ".";

/**
 * Represents a hook to retrieve an experiment.
 * @param name The name of the experiment.
 * @param fireExperimentExposure Boolean indicating if an exposure event should be fired.
 * @returns The configuration for the experiment.
 */
export const useExperiment = (
    name: string,
    fireExperimentExposure: boolean = true
) => {
    return useMemo(
        () =>
            fireExperimentExposure
                ? Experiments.getExperiment(name)
                : Experiments.getExperimentWithExposureLoggingDisabled(name),
        [name, fireExperimentExposure]
    );
};

/**
 * Represents a hook to retrieve an experiment cohort.
 * @param name The name of the experiment.
 * @param defaultValue The default value.
 * @param fireExperimentExposure Boolean indicating if an exposure event should be fired.
 * @returns The configuration for the experiment.
 */
export const useExperimentCohort = (
    name: string,
    defaultValue: string,
    fireExperimentExposure?: boolean
) => {
    return useMemo(
        () =>
            Experiments.getExperimentCohort(
                name,
                defaultValue,
                fireExperimentExposure
            ),
        [name, defaultValue, fireExperimentExposure]
    );
};
